import Axios from 'axios';
import Qs from 'qs';

export default {

  // 社区分页列表
  listPage(
    name,
    place,
    state,
    page,
    limit
  ) {
    return Axios.get('/community/api/admin/communities', {
      params: {
        filter: {
          name,
          state
        },
        sort: {
          id: 'desc'
        },
        place,
        page,
        limit
      },
      paramsSerializer(params) {
        return Qs.stringify(params);
      }
    });
  },

  // 添加社区
  add(
    name,
    prefix,
    province,
    city,
    area,
    tissue_staff,
    mj_switch,
    gate_switch,
    mobile,
    state
  ) {
    return Axios.post('/community/api/admin/communities', {
      name,
      prefix,
      province,
      city,
      area,
      tissue_staff,
      mj_switch,
      gate_switch,
      mobile,
      state
    });
  },

  // 编辑社区
  edit(
    id,
    name,
    prefix,
    province,
    city,
    area,
    tissue_staff,
    mj_switch,
    gate_switch,
    mobile,
    state
  ) {
    return Axios.patch(`/community/api/admin/communities/${id}`, {
      name,
      prefix,
      province,
      city,
      area,
      tissue_staff,
      mj_switch,
      gate_switch,
      mobile,
      state
    });
  },

  // 删除社区
  del(
    id
  ) {
    return Axios.delete(`/community/api/admin/communities/${id}`);
  },

  // 社区信息
  info(
    id
  ) {
    return Axios.get(`/community/api/admin/communities/${id}`);
  },

  // 启用社区
  enable(
    id
  ) {
    return Axios.post(`/community/api/admin/communities/enable/${id}`);
  },

  // 禁用社区
  disable(
    id
  ) {
    return Axios.post(`/community/api/admin/communities/disable/${id}`);
  },

  // 社区物业人员
  staff(
    community_id
  ) {
    return Axios.get('/property/api/admin/staff/by-community', {
      params: {
        community_id
      }
    });
  },

  faceChange(id, status) {
    return Axios.post(`/community/api/admin/communities/setFaceStatus/${id}`, { status }
    )
  }


}